module.exports = __webpack_public_path__ + "img/painter_artist.f25b8363.png";